import React from 'react'
import { IconButton, Tooltip } from '@material-ui/core'
import { ChatBubbleOutline } from '@material-ui/icons'

const ContextButton = ({ parentType, parentId, parentLabel, onOpenDrawer }) => {
  return (
    <Tooltip title="Context" placement="top">
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation()
          onOpenDrawer && onOpenDrawer({ parent_type: parentType, parent_id: parentId, parent_label: parentLabel })
        }}
        style={{ padding: 4, color: 'var(--ink-4, #9e9e9e)' }}
        onMouseEnter={e => e.currentTarget.style.color = '#1f5e3a'} // should match var(--brand)
        onMouseLeave={e => e.currentTarget.style.color = '#97a094'} // should match var(--ink-4)
      >
        <ChatBubbleOutline style={{ fontSize: 16 }} />
      </IconButton>
    </Tooltip>
  )
}

export default ContextButton
